import { Input, InputBaseProps } from './Input';

const allowedKeys = /[^0-9]/g;

interface InputNumberProps extends InputBaseProps {
  minValue?: number;
  maxValue?: number;
}

const normalizeNumberValue = (
  value: string,
  minValue?: number,
  maxValue?: number,
) => {
  let normalizedValue = value.replace(allowedKeys, '');
  normalizedValue =
    normalizedValue.length >= 2 ? normalizedValue.replace(/^0+/, '') : normalizedValue;

  if (!normalizedValue) return normalizedValue;

  const numericValue = Number(normalizedValue);

  if (maxValue !== undefined && numericValue > maxValue) {
    return String(maxValue);
  }

  if (
    minValue !== undefined &&
    numericValue < minValue &&
    normalizedValue.length >= String(minValue).length
  ) {
    return String(minValue);
  }

  return normalizedValue;
};

export const InputNumber: React.FC<InputNumberProps> = ({
  onInput,
  onChange,
  minValue,
  maxValue,
  ...props
}: InputNumberProps) => {
  const applyValueLimits = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = normalizeNumberValue(e.target.value, minValue, maxValue);
  };

  const handleOnInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    applyValueLimits(e);
    onInput?.(e);
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    applyValueLimits(e);
    onChange?.(e);
  };

  return <Input onInput={handleOnInput} onChange={handleOnChange} {...props} />;
};
